import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import type {useCustomFieldHandlers} from '../../../hooks/use-custom-field-handlers';

import type {CardWidgetKey} from '../../../../core/card/types';

import {useGetWidgetCustomFields} from '../graphql/hooks/use-get-widget-custom-fields';

import {CustomFieldsWidgetShell} from './custom-fields-widget-shell';

interface Props {
    entityId: string;
    widget: Widget;
    handlers: ReturnType<typeof useCustomFieldHandlers>;
    emptyStateKey: CardWidgetKey;
}

export function CustomFieldsWidget(props: Props) {
    const {customFields, isFirstLoad} = useGetWidgetCustomFields(props.entityId, props.widget.id);

    return (
        <CustomFieldsWidgetShell
            entityId={props.entityId}
            widget={props.widget}
            handlers={props.handlers}
            emptyStateKey={props.emptyStateKey}
            customFields={customFields}
            isFirstLoad={isFirstLoad}
        />
    );
}
